/**
 * The default locale of the app.
 */
export const APP_DEFAULT_LOCALE = 'en'
export const APP_LANGUAGE_LIST = [
  { name: 'English', locale: 'en' },
  { name: 'ภาษาไทย', locale: 'th' },
]

/**
 * API timeout interval (in seconds)
 */
export const API_TIMEOUT_INTERVAL = 60 * 1000

/**
 * Files with below extensions will get classified as images.
 */
export const IMAGE_FILE_TYPES_LIST = ['jpg', 'jpeg', 'png', 'gif']

/**
 * Default goxip paylink domains.
 */
export const GOXIP_PAYLINK_DOMAIN = 'https://love.goxip.com'
export const GOXIP_PAYLINK_DOMAIN_TH = 'https://love.goxip.co.th'

/**
 * Google API client id.
 */
export const GOOGLE_API_CLIENT_ID = '625398947669-3h44jj7dkf6389od8e925vlrsoqjmu92.apps.googleusercontent.com'

/**
 * The time between each app update check
 */
export const CHECK_APP_UPDATE_POLLING_INTERVAL = 1000 * 60 * 30 * 1 // 30 mins

/**
 * A list of supported editorial item types.
 */

export const EDITORIAL_ITEMS = [
  { value: 'image', label: 'Image', types: ['value'] },
  { value: 'image_link', label: 'Image Link', types: ['value', 'link'] },
  { value: 'text', label: 'Text', types: ['value'] },
  { value: 'text_link', label: 'Text Link', types: ['value', 'link', 'css'] },
  { value: '1_product', label: '1 Product', types: ['product'] },
  { value: '2_product', label: '2 Products', types: ['product'] },
  { value: '3_product', label: '3 Products', types: ['product'] },
  { value: '4_product', label: '4 Products', types: ['product'] },
  { value: 'youtube', label: 'Embed Youtube', types: ['value'] },
  { value: 'instagram', label: 'Embed Instagram', types: ['value'] },
  { value: 'parallax_adsense', label: 'AdSense (FB only)', types: ['value'] },
]

export const orderStatusList = [
  {
    name: 'Full Refunded',
    key: 'full_refund',
  },
  {
    name: 'Partially Refunded',
    key: 'partial_refund',
  },
]

/**
 * Payment Status List
*/
export const paymentStatusList = [
  {
    name: 'Pending From Merchant',
    key: 'pending_from_merchant',
  },
  {
    name: 'Merchant Authorised, Pending Payment',
    key: 'pending_approval',
  },
  {
    name: 'Ready To Paid In Next Cycle',
    key: 'ready_to_paid',
  },
  {
    name: 'Paid',
    key: 'paid',
  },
  {
    name: 'Order Refunded',
    key: 'refunded',
  },
  {
    name: 'Order Partially Refunded',
    key: 'partially_refunded',
  },
  {
    name: 'Order Partially Refunded, Merchant Authorised, Pending Payment',
    key: 'partially_refunded_pending_approval',
  },
]

export const currencyList = [
  { value: 'USD', name: 'USD' },
  { value: 'THB', name: 'THB' },
  { value: 'HKD', name: 'HKD' },
  { value: 'GBP', name: 'GBP' },
  { value: 'SGD', name: 'SGD' },
  { value: 'CAD', name: 'CAD' },
  { value: 'AUD', name: 'AUD' },
  { value: 'JPY', name: 'JPY' },
]

// order determines the order of tab list on featured list page
export const featuredTypeList = [
  'home_carousel',
  'home_editorials',
  'home_slide_banners',
  'marketplace_carousel',
  'magazines',
]

export const countryList = [
  { value: 'HK', name: 'Hong Kong' },
  { value: 'TH', name: 'Thailand' },
  { value: 'AU', name: 'Australia' },
  { value: 'IN', name: 'Indonesia' },
  { value: 'MY', name: 'Malaysia' },
  { value: 'PH', name: 'Philippines' },
  { value: 'SG', name: 'Singapore' },
  { value: 'GB', name: 'United Kingdom' },
  { value: 'US', name: 'United States' },
  { value: 'CA', name: 'Canada' },
  { value: 'TW', name: 'Taiwan' },
]
export const countryCodeList = countryList.map(country => country.value.toLowerCase())

export const categoryList = [
  { id: 291, text: 'Womens' },
  { id: 292, text: 'Beauty' },
  { id: 293, text: 'Mens' },
  { id: 294, text: 'Grooming' },
  { id: 316, text: 'Lifestyle' },
]

export const baseLanguages = [
  { key: 'en', suffix: '' },
  { key: 'enTW', suffix: '_en_tw' },
  { key: 'zhHK', suffix: '_zh_hk' },
  { key: 'zhCN', suffix: '_zh_cn' },
  { key: 'zhTW', suffix: '_zh_tw' },
  { key: 'th', suffix: '_th_th' },
]

export const simpleLanguages = [
  { key: 'en', suffix: '' },
  { key: 'zhHK', suffix: '_zh_hk' },
  { key: 'zhCN', suffix: '_zh_cn' },
]
